import React from 'react';

interface Props {
  country?: string;
}

const Privacy = ({ country }: Props) => (
  <>
    {(country === 'BR' || country === '55') && (
      <>
        <div>
          <p>Rappi BR.</p>

          <p>
            <b>
              Aviso de Privacidade e <br />
              Políticas de uso das Informação utilizadas pela Rappi
            </b>
          </p>

          <p>
            Este documento, denominado Política de Privacidade, possui finalidade de estabelecer as regras sobre o uso,
            armazenamento e tratamento dos dados e informações coletadas dos USUÁRIOS na PLATAFORMA RAPPI.
          </p>

          <p>
            Responsáveis pelas Informações dos USUÁRIOS:&nbsp;
            <b>RAPPI BRASIL INTERMEDIAÇÃO DE NEGÓCIOS LTDA.</b>, registrada sob o CNPJ 26.900.161/0001-25, com sede na
            Av. dos Autonomistas, 896, torre 1, cj 1211, Vila Yara, Osasco/SP, Brasil, CEP. 06020-010 e suas filiadas
            (“RAPPI”).
          </p>

          <p>
            Quando Você acessar, utilizar ou interagir com a Plataforma, podemos coletar Dados Pessoais sobre Você. Este
            documento (que também chamaremos de “Política de Privacidade” ou simplesmente de “Política”) tem o propósito
            de esclarecer como Dados Pessoais podem ser coletados, usados, compartilhados, armazenados na e de qualquer
            forma tratados na nossa operação da Plataforma.
          </p>

          <p>
            <b>1.Definições importantes:</b>
          </p>

          <p>
            <b>ARRANJO DE PAGAMENTO VISA</b>: é o arranjo de pagamento instituído pela Visa, empresa responsável pela
            marca e pelos sistemas físicos e digitais que permitem a emissão do Cartão e utilização em diferentes
            estabelecimentos credenciados, de acordo com a Lei nº 12.865/2013, e com o{' '}
            <em>Regulamento dos Arranjos de Pagamento da Visa do Brasil</em>, disponível no site da Visa, realizados
            através de RappiPay cartão.
          </p>

          <p>
            <b>BANCO DE DADOS:</b>&nbsp;Conjunto estruturado de dados pessoais ou anônimizados, localizado em um ou em
            vários locais, em suporte eletrônico ou físico;
          </p>

          <p>
            <b>CARTÃO:</b> é um cartão físico e/ou virtual que, a critério da RAPPI, pode ser oferecido aos Consumidores
            para usufruírem de serviços financeiros.
          </p>

          <p>
            <b>CONSENTIMENTO:</b>&nbsp;É a manifestação livre, informada e inequívoca pela qual o USUÁRIO concorda com o
            tratamento dos seus Dados Pessoais para finalidades específicas.
          </p>

          <p>
            <b>CONSUMIDORES</b>: São as pessoas naturais que se cadastraram na Plataforma e a utilizam para solicitar a
            realização de Encargos.
          </p>

          <p>
            <b>CONTA</b>: Uma vez realizado e aprovado o cadastro do Consumidor, será criada uma conta de pagamento na
            estrutura da RAPPI para viabilizar a execução de transações de pagamento mediante gestão dos valores
            aportados pelo Consumidor.{' '}
          </p>

          <p>
            <b>CONTEÚDO</b>: Qualquer informação, dados, comunicações, software, fotos, vídeos, gráficos, música, sons e
            outros materiais e serviços que podem ser visualizados pelos USUÁRIOS na PLATAFORMA. Isso inclui mensagens,
            conversas, bate-papo e outros conteúdos originais.
          </p>

          <p>
            <b>COOKIES:</b>&nbsp;Arquivos enviados pelo servidor da PLATAFORMA para o dispositivo do USUÁRIO, com a
            finalidade de identificar o seu dispositivo e obter dados de acesso, como páginas navegadas ou links
            clicados, permitindo, desta forma, personalizar a utilização da PLATAFORMA, de acordo com o seu perfil.
            Também podem ser utilizados para garantir uma maior segurança dos USUÁRIOS da PLATAFORMA.{' '}
            <em>
              Para mais informações sobre como Cookies e tecnologias similares são utilizadas pela Rappi, por favor
              consulte a nossa{' '}
            </em>
            <a href="https://reservas.netactica.com/corporate/terminos_condiciones_v2.pdf">
              <em>Política de Cookies</em>
            </a>
            <em>.</em>
          </p>

          <p>
            <b>DADOS PESSOAIS</b>: informações relacionadas a uma pessoa natural (identificada ou identificável),
            incluindo números identificativos, dados de localização, identificadores eletrônicos, ou qualquer informação
            que, quando combinada com outras informações, seja capaz de identificar alguém, torná-la identificável ou,
            ainda, individualizá-la.
          </p>

          <p>
            <b>DADOS PESSOAIS ANONIMIZADOS ou ANONIMIZADOS</b>: dados relativos a um USUÁRIO que não possa ser
            identificado.
          </p>

          <p>
            <b>ENCARGOS:</b>&nbsp;são todos os tipos de solicitação que podem ser feitas por Consumidores e realizadas
            por Mandatários por meio da Plataforma, incluindo a aquisição de produtos e a entrega de encomendas. Para
            mais detalhes sobre como funcionam os Encargos, por favor consulte os{' '}
            <a href="https://reservas.netactica.com/corporate/terminos_condiciones_v2.pdf">
              Termos de Uso da Plataforma
            </a>
            .
          </p>

          <p>
            <b>ESTABELECIMENTOS PARCEIROS:</b>&nbsp;são os estabelecimentos comerciais que mantêm relação de parceria
            com a Rappi, a partir dos quais podem ser solicitados pedidos e Encargos para realização pelos Mandatários.
          </p>

          <p>
            <b>IP (Internet Protocol):</b>&nbsp;É um conjunto de números que identifica o computador do USUÁRIO na
            Internet.
          </p>

          <p>
            <b>JANELAS (Pop-Ups):</b>&nbsp;Janela ou aviso da internet que emerge automaticamente em qualquer momento
            quando a PLATAFORMA é utilizada, inclusive na formalização dos Termos e Condições do Uso da Plataforma e na
            Política de Privacidade.
          </p>

          <p>
            <b>LOGS</b>: registros de atividades do USUÁRIO efetuadas na PLATAFORMA.
          </p>

          <p>
            <b>RAPPI</b>: é a empresa proprietária e possuidora de todos os direitos autorais referente a Plataforma de
            Internet denominada RAPPI.
          </p>

          <p>
            <b>PARCEIRA DO ARRANJO DO ARRANJO </b>: é a empresa responsável pela emissão do Cartão, sob o Arranjo de
            Pagamento Visa, que possui uma conta de pagamento atrelada a ele, com saldo zerado, que será entregue pela
            RAPPI.
          </p>

          <p>
            <b>MANDATÁRIOS:</b> compõe uma categoria específica de Usuários, sendo as pessoas naturais parceiras da
            Rappi que se cadastraram na Plataforma e a utilizam para realizar Encargos a pedido de Consumidores.
          </p>

          <p>
            <b>MENSAGENS DE DADOS:</b>&nbsp;A informação gerada, enviada, recebida, armazenada ou comunicada por meios
            eletrônicos, óticos ou similares. Exemplificando: os formulários de cadastramento, o Intercâmbio Eletrônico
            de Dados (EDI – Electronic Data Interchange), Internet, o correio eletrônico, chats entre outros meios de
            comunicação
          </p>

          <p>
            <b>PLATAFORMA RAPPI:</b>&nbsp;aplicativo web e móvel administrado e com os direitos exclusivos de utilização
            no Brasil pela RAPPI, através do qual, em conjunto com a PARCEIRA DO ARRANJO: i) são exibidos diferentes
            produtos de consumo de forma publicitária (dos Prestadores de Serviço) para que possam servir de referência
            ao Consumidor; ii) facilita a aproximação entre os Consumidores e os Prestadores de Serviço; iii) serve como
            meio de envio de comunicações entre o Consumidor e a RAPPI; iv) se aplicável, oferta Cartão e Conta ao
            Consumidor, por meio dos quais este pode movimentar recursos financeiros e realizar transações de pagamento;
            e v) pode receber os pagamentos das compras diretamente do consumidor (por conta e ordem de terceiros), com
            repasse do dinheiro ao Prestador de Serviço. &nbsp;A RAPPI não realiza a compra de produtos por conta
            própria, não armazena produtos e tampouco é vendedora de produtos. É uma plataforma de tecnologia somente
            para intermediação da Venda, cobrando pelos serviços realizados<b>.&nbsp;</b>Também denominada neste
            Instrumento como&nbsp;<b>“PLATAFORMA”,&nbsp;</b>podendo ser acessada por&nbsp;
            <em>computadores, notebooks</em>
            <b>,&nbsp;</b>
            <em>smartphones</em>&nbsp;ou&nbsp;<em>tablets.</em>
          </p>

          <p>
            <b>SERVIÇO ou SERVIÇOS:</b>&nbsp;Serviços oferecidos por meio da PLATAFORMA.
          </p>

          <p>
            <b>SESSION ID</b>: identificação da sessão do USUÁRIO no processo de inscrição ou quando utilizado de alguma
            forma na PLATAFORMA.
          </p>

          <p>
            <b>TERMOS E CONDIÇÕES DE USO DA PLATAFORMA ou TERMOS DE USO</b>: Constituem os termos legais que
            regulamentam a relação entre a RAPPI, a PARCEIRA DO ARRANJO DO ARRANJO&nbsp; e os USUÁRIOS.
          </p>

          <p>
            <b>TRATAMENTO</b>: é qualquer tipo de atividade baseada em Dados Pessoais, incluindo, por exemplo, as
            seguintes atividades: coleta, registro, armazenamento, organização consulta, uso, divulgação,
            compartilhamento, transmissão, classificação, reprodução, processamento e avaliação.
          </p>

          <p>
            <b>USUÁRIO</b>: é a pessoa natural usuária da Plataforma RAPPI, identificada neste Instrumento como USUÁRIO.
          </p>

          <p>
            <b>USUÁRIO DA PLATAFORMA RAPPI</b>: são as pessoas físicas cadastradas na Plataforma de Internet
            denominada&nbsp;<b>RAPPI&nbsp;</b>também denominados&nbsp;<b>“USUÁRIO”</b>,
            <b>&nbsp;“USUÁRIOS”, “TITULAR DO DADO” ou “VOCÊ”. </b>
          </p>

          <p>
            A <b>RAPPI</b> e o <b>USUÁRIO</b> poderão ser mencionados individualmente neste Instrumento como “Parte” ou
            em conjunto como “Partes”.
          </p>

          <p>
            <b>2.Obtenção e Uso dos Dados e Informações dos Usuários:</b>
          </p>

          <p>
            Os dados e informações (sejam eles PESSOAIS ou ANONIMIZADOS) serão obtidos quando o USUÁRIO: (a) Passar a
            utilizar os SERVIÇOS da PLATAFORMA; (b) Interagir com as diversas ferramentas existentes na PLATAFORMA,
            fornecendo as informações voluntariamente ou involuntariamente (no caso de obtenção de informações sobre a
            frequência de utilização da PLATAFORMA ou os tipos de informações envolvidas; ou (c) Entrar em contato por
            meio dos canais de comunicação disponíveis na PLATAFORMA.{' '}
          </p>

          <p>
            Com exceção do disposto no item 4 desta Política abaixo, a RAPPI e a PARCEIRA DO ARRANJO DO ARRANJO não
            alugam, não vendem e não compartilham as informações pessoais com outras pessoas ou com empresas não
            afiliadas, exceto com o objetivo de fornecer ao USUÁRIO os produtos e serviços solicitados na PLATAFORMA,
            tendo obtido para tanto a sua permissão, ou em circunstâncias específicas, como ordem judicial ou advindas
            de lei.
          </p>

          <p>
            Poderão ser solicitados dos USUÁRIOS do <b>ARRANJO DE PAGAMENTO VISA</b>, dentre outros, os seguintes dados:
            CPF/CNPJ, nome completo, data de nascimento, endereço residencial, endereço de e-mail, nome completo da mãe
            e número de telefone, cópia de documento de identidade ou de Carteira Nacional de Habilitação, “selfie”,
            autodeclaração de Pessoa Exposta Politicamente (se aplicável), IP, hora e data de acesso, geolocalização,
            dados sobre o dispositivo de acesso e cookies, perfil e comportamento de compra, volume e número de
            transações e por meio da Plataforma, dados gerais de navegabilidade, utilização da Plataforma e funis de
            eventos.
          </p>

          <p>
            <b>3.Prazos de Armazenamento dos Dados e Informações</b>:
          </p>

          <p>
            Todas as MENSAGENS DE DADOS e informações coletadas dos USUÁRIOS serão incorporados ao BANCO DE DADOS da
            PLATAFORMA, sendo seus responsáveis e proprietários a RAPPI e a PARCEIRA DO ARRANJO. Os dados e informações
            coletados estarão armazenados em ambiente seguro, observado o estado da técnica disponível e criptografados,
            e somente poderão ser acessados por pessoas qualificadas e autorizadas pela RAPPI e/ou pela PARCEIRA DO
            ARRANJO. Considerando que nenhum sistema de segurança é absolutamente seguro, a RAPPI e a PARCEIRA DO
            ARRANJO DO ARRANJO se eximem de quaisquer responsabilidades por eventuais danos e/ou prejuízos decorrentes
            de falhas, vírus ou invasões do BANCO DE DADOS na PLATAFORMA.{' '}
          </p>

          <p>
            Nós manteremos seus Dados Pessoais somente pelo tempo que for necessário para cumprir com as finalidades
            para as quais os coletamos, inclusive para fins de cumprimento de quaisquer obrigações legais, contratuais,
            de prestação de contas ou requisição de autoridades competentes.
          </p>

          <p>
            Para determinar o período de retenção adequado para cada tipo de Dado Pessoal tratado pela Rappi, sempre
            consideramos a quantidade, a natureza e a sensibilidade de tais Dados, o risco potencial de danos
            decorrentes do seu uso não autorizado ou da sua divulgação, a finalidade do tratamento e se podemos alcançar
            tais propósitos por outros meios, e os requisitos legais aplicáveis.
          </p>

          <p>
            <b>4.Uso dos Dados e Informações:</b>
          </p>

          <p>
            A quantidade e o tipo de Dados Pessoais coletados pela Rappi variam conforme o seu uso da Plataforma.
            Coletaremos diferentes Dados caso você seja um Consumidor utilizando a Plataforma, um Mandatário ou um
            representante de um dos nossos Estabelecimentos Parceiros.{' '}
          </p>

          <p>
            Para esclarecer essas questões, listamos abaixo algumas finalidades para as quais seus Dados podem ser
            utilizados, dependendo da sua forma de utilização da Plataforma, para que você possa entender o que se
            aplica especificamente a você:
          </p>

          <ul>
            <li>
              <b>Consumidores</b>: Caso você use a Plataforma como um Consumidor, isto é, um Usuário que envia Encargos
              para que a Rappi possa conectá-lo a um Mandatário para que este possa, por sua vez, atender ao seu pedido
              e realizar o seu Encargo, poderemos coletar Dados a partir da sua utilização da Plataforma e do seu
              cadastro, conforme detalhado a seguir:
              <br /> <br />
              <u>Cadastro na Plataforma</u>
              <br />
              <br />
              <b>Tipo de Dados Coletados: </b>
              <b>Dados de cadastro</b>: nome, e-mail, telefone, endereço de entrega, CPF, número do cartão para
              pagamento (quando este é o método de pagamento) e, quando for solicitado um Cartão, CNH, data de
              nascimento, endereço residencial, nome da mãe, foto e autodeclaração de Pessoa Exposta Politicamente.
              <br />
              <br />
              <b>Finalidade: </b> Cadastro na Plataforma, solicitação e entrega de pedidos, realização de operações de
              pagamento, envio de comprovantes de pedidos, envio de brindes, contatos telefônico (ligação, SMS, push e
              WhatsApp) e emissão do Cartão.
              <br />
              <br />
              <u>Interação com a Plataforma</u>
              <br />
              <br />
              <b>Tipo de Dados Coletados: </b>
              <b>Dados de navegação</b>: endereço do IP, IMEI do dispositivo do Usuário, dados locacionais e
              comportamento de consumo na Plataforma para análise de preferências. &nbsp;
              <b>Dados sobre o dispositivo de acesso</b>: endereço do IP, IMEI do dispositivo do usuário e dados
              locacionais.
              <br />
              <br />
              <b>Finalidade: </b> Análise do perfil de consumo, perfilhamento para fins de inteligência de mercado e
              envio de publicidade própria e de terceiros.
            </li>
          </ul>

          <ul>
            <li>
              <b>Mandatários</b>: Caso você use a Plataforma como um Mandatário, isto é, um Usuário que realiza Encargos
              para atender às solicitações de Consumidores, poderemos coletar Dados a partir da sua utilização da
              Plataforma e do seu cadastro, conforme detalhado a seguir:
              <br /> <br />
              <u>Cadastro na Plataforma</u>
              <br />
              <br />
              <b>Tipo de Dados Coletados: </b>
              <b>Dados de cadastro</b>: nome, e-mail, RG, CPF, CNH, placa da moto (quando aplicável) e endereço
              residencial, dados bancários (banco agência e conta corrente)
              <br />
              <br />
              <b>Finalidade: </b> Cadastro na Plataforma, solicitação e entrega de pedidos, realização de operações de
              pagamento, contatos telefônico (ligação, SMS, push e WhatsApp), envio de comprovantes de pedidos e envio
              de brindes. &nbsp; Análise do perfil do Mandatário, verificação do cumprimento dos Encargos e envio de
              publicidade.
              <br />
              <br />
              <u>Interação com a Plataforma</u>
              <br />
              <br />
              <b>Tipo de Dados Coletados: </b> <b>Dados sobre o dispositivo de acesso</b>: endereço do IP, IMEI do
              dispositivo e geolocalização no momento da entrega <br />
              <br />O aplicativo ‘Soy Rappi’ coleta e armazena o número de telefone do usuário que é armazenado em nosso
              banco de dados usando métodos de criptografia para garantir a proteção das informações pessoais do
              usuário. Os dados coletados são usados ​​para identificar possíveis comportamentos atípicos dentro do
              aplicativo e não são compartilhados ou transferidos a terceiros.
            </li>
          </ul>

          <ul>
            <li>
              <b>Representantes de Estabelecimentos Parceiros</b>: Caso você use a Plataforma como um representante de
              um dos nossos Estabelecimentos Parceiros, isto é, um Usuário que recebe pedidos realizados por
              Consumidores para preparo e posterior entrega a um Mandatário designado pela Rappi, poderemos coletar
              Dados a partir da sua utilização da Plataforma e do seu cadastro, conforme detalhado a seguir:
              <br /> <br />
              <u>Cadastro na Plataforma e Formalização de Contrato</u>
              <br />
              <br />
              <b>Dados de cadastro</b>: nome do representante legal e CPF, número de telefone do representante, dados
              bancários (banco, agência e conta corrente), endereço do IP e IMEI do dispositivo do responsável pela
              assinatura do contrato.
              <br />
              <br />
              <b>Finalidade: </b> Cadastro na Plataforma, cumprimento da parceria comercial e criação da loja virtual do
              Estabelecimento Parceiro na Plataforma.
            </li>
          </ul>

          <p>
            Os registros mencionados poderão ser utilizados pela RAPPI em casos de investigação de fraudes ou de
            alterações indevidas em seus sistemas e cadastros, assim como no compartilhamento com terceiros de forma
            anonimizada.
          </p>

          <p>
            <b>5.COM QUEM A RAPPI COMPARTILHA DADOS PESSOAIS?</b>
          </p>

          <p>
            Para viabilizar a operação da Plataforma, a Rappi depende de relações específicas com diferentes pessoas,
            incluindo parceiros de negócio. Nessas relações, é possível que Dados Pessoais sejam compartilhados para
            suportar o regular funcionamento da Plataforma, como no contexto da prestação de serviços de hospedagem de
            dados, por exemplo. Desta forma, nos reservamos o direito de compartilhar seus Dados Pessoais com os grupos
            de recipientes abaixo indicados, sempre respeitando a legislação brasileira, e adotaremos as medidas
            jurídicas, técnicas e organizacionais adequadas visando à preservação da sua privacidade e da integridade de
            seus Dados Pessoais.
          </p>

          <p>
            Listamos abaixo os contextos nos quais compartilhamos Dados Pessoais, as finalidades de cada
            compartilhamento e os respectivos recipientes dos Dados em cada caso:
            <br /> <br />
            <u>
              Recipiente dos Dados: <b>Mandatários</b>
            </u>
            <br />
            <br />
            <b>Tipos de Dados Compartilhados: </b> Nome, endereço e detalhes sobre Encargos solicitados na Plataforma
            pelos Consumidores
            <br />
            <br />
            <b>Finalidade do Compartilhamento: </b> Mandatários têm acesso a tais Dados Pessoais de Consumidores durante
            a realização dos Encargos para que possam realizá-los corretamente, na forma solicitada pelos Consumidores.
            Nota: Os detalhes de Encargos referentes a produtos específicos adquiridos por Consumidores só são
            compartilhados com Mandatários quando os Mandatários devem selecionar, adquirir e retirar os produtos
            desejados pelos Consumidores nos Estabelecimentos Parceiros.
            <br /> <br />
            <u>
              Recipiente dos Dados: <b>Consumidores</b>
            </u>
            <br />
            <br />
            <b>Tipos de Dados Compartilhados: </b> Nome, dados de localização e placa da moto dos Mandatários
            <br />
            <br />
            <b>Finalidade do Compartilhamento: </b>Consumidores têm acesso a tais Dados Pessoais de Mandatários para que
            possam acompanhar a realização dos Encargos solicitados e interagir com os Mandatários com segurança,
            podendo facilmente identificá-los e, havendo necessidade, interagir com estes.
            <br /> <br />
            <u>
              Recipiente dos Dados: <b>Estabelecimentos Parceiros</b>
            </u>
            <br />
            <br />
            <b>Tipos de Dados Compartilhados: </b> Detalhes sobre pedidos realizados na Plataforma, CPF (caso queira
            este dado na fatura ou trate-se de dado obrigatório para faturamento – ex. NF-e), primeiro nome do
            Consumidor e primeiro nome do Mandatário
            <br />
            <br />
            <b>Finalidade do Compartilhamento: </b>Estabelecimentos Parceiros recebem estes Dados para garantir o
            correto atendimento dos pedidos dos Consumidores e a correta identificação dos Mandatários para viabilizar a
            entrega dos produtos adquiridos e emissão de Nota Fiscal. Nota: O nome, o e-mail, o telefone e demais Dados
            dos Consumidores só são compartilhados com os Estabelecimentos Parceiros mediante o consentimento específico
            e destacado do Consumidor, para finalidades específicas, por exemplo, para fins de marketing ou participação
            em programas de fidelidade.
            <br /> <br />
            <u>
              Recipiente dos Dados: <b>Nome completo, endereço e telefone do Consumidor</b>
            </u>
            <br />
            <br />
            <b>Tipos de Dados Compartilhados: </b> Quando o Consumidor utiliza a Plataforma para adquirir produtos cuja
            entrega seja operacionalizada pelos Estabelecimentos Parceiros (e não por Mandatários), tais Dados Pessoais
            também são compartilhados com o Estabelecimento Parceiro envolvido para possibilitar a entrega dos produtos
            selecionados.
            <br />
            <br />
            <u>
              Recipiente dos Dados: <b>Fornecedores de Tecnologia e de Serviços Financeiros</b>
            </u>
            <br />
            <br />
            <b>Tipos de Dados Compartilhados: </b> Todos os Dados Pessoais coletados na Plataforma
            <br />
            <br />
            <b>Finalidade do Compartilhamento: </b>Temos uma série de fornecedores que precisamos contratar para operar
            a Plataforma, e alguns deles podem tratar em nosso nome os Dados Pessoais que coletamos. Por exemplo, temos
            serviços de hospedagem de dados contratados na Amazon Web Services, arranjos de pagamento que possibilitam a
            realização de transações financeiras na Plataforma (incluindo a Visa e o Emissor) e serviços de análise de
            dados que nos permitem entender melhor como a Plataforma é utilizada para que possamos sempre aprimorá-la.
            Nota: A Visa e o Emissor poderão ter acesso aos Dados Pessoais dos Consumidores portadores do Cartão também
            para fins de disponibilização de ofertas, descontos e promoções e para permitir a interação do Consumidor
            com as plataformas promocionais da Visa.
          </p>

          <p>
            Alguns Dados Pessoais tratados na Plataforma também podem ser tratados de forma conjunta pela Rappi com
            outras empresas do seu grupo econômico Rappi para fins de reporte e inteligência de mercado. Nesses casos,
            os Dados Pessoais envolvidos podem ser transferidos para fora do Brasil, mais especificamente para Estados
            Unidos, Colômbia, México, Argentina, Peru, Equador, Chile e Costa Rica.
          </p>

          <p>
            <b>5.Cookies</b>:
          </p>

          <p>
            A PLATAFORMA poderá fazer o uso de COOKIES e tecnologias similares para customizar a experiência dos
            Usuários na Plataforma e para gerar informações relevantes sobre a forma de uso da Plataforma pelos Usuários
            para a Rappi. Para entender como Cookies e tecnologias similares são utilizadas pela Rappi e para exercer
            seus direitos de escolha quanto ao uso de referidas tecnologias na Plataforma, por favor verifique a nossa
            <a href="https://reservas.netactica.com/corporate/terminos_condiciones_v2.pdf"> </a>
            <a href="https://reservas.netactica.com/corporate/terminos_condiciones_v2.pdf">Política de Cookies</a>.
          </p>

          <p>
            <b>6.Direitos do USUÁRIO:</b>
          </p>

          <p>
            Seus Dados Pessoais são seus e a legislação brasileira lhe garante, na sua condição de Titular de Dados
            Pessoais, uma série de direitos relacionados aos seus Dados. Nós estamos comprometidos com o cumprimento
            desses direitos e, nessa seção, explicaremos quais são esses direitos e como você pode exercê-los junto à
            Rappi.{' '}
          </p>

          <ul>
            <li>
              <b>Confirmação de existência de tratamento</b>: Você pode solicitar a nossa confirmação acerca da
              existência ou inexistência de atividades de tratamento dos seus Dados Pessoais.
            </li>
          </ul>

          <ul>
            <li>
              <b>Acesso aos seus Dados Pessoais</b>: Você pode requisitar e receber uma cópia dos seus Dados Pessoais
              que nós possuímos sobre você.
            </li>
          </ul>

          <ul>
            <li>
              <b>Retificação dos seus Dados Pessoais: </b>Você pode solicitar a correção e/ou retificação dos seus Dados
              Pessoais, caso você identifique que alguns deles estão incorretos. Contudo, para ser efetivada essa
              correção, possivelmente precisaremos checar a validade dos Dados que você nos fornecerá.
            </li>
          </ul>

          <ul>
            <li>
              <b>Eliminação dos seus Dados Pessoais: </b>Você pode solicitar a exclusão dos seus Dados Pessoais das
              bases de dados que utilizamos para tratá&nbsp;&nbsp;&nbsp;&nbsp; -los. Todos os Dados coletados serão
              excluídos de nossos servidores quando você assim requisitar ou quando estes não forem mais necessários ou
              relevantes para lhe oferecermos os nossos serviços, salvo se houver qualquer outra razão para a sua
              manutenção, como eventual obrigação legal de retenção de Dados ou necessidade de preservação destes para
              resguardar direitos da Rappi.
            </li>
          </ul>

          <ul>
            <li>
              <b>Objeção ao tratamento de Dados Pessoais</b>:Você pode contestar a nossa forma de tratamento dos seus
              Dados Pessoais para determinadas finalidades. Em certas situações, podemos demonstrar que temos motivos
              legítimos para tratar seus Dados, os quais podem eventualmente se sobrepor aos seus direitos, caso, por
              exemplo, sejam estritamente essenciais para a funcionalidade de determinado aspecto da Plataforma.
            </li>
          </ul>

          <ul>
            <li>
              <b>Portabilidade dos seus Dados Pessoais</b>: Você pode solicitar o fornecimento direto a você (ou a
              terceiros que você escolher) dos seus Dados Pessoais em formato estruturado e interoperável.
            </li>
          </ul>

          <ul>
            <li>
              <b>Revogação do consentimento: </b>Nashipóteses em que você tiver fornecido o seu consentimento para que
              pudéssemos realizar atividades de tratamento específicas com seus Dados Pessoais, você pode retirar o seu
              consentimento. Isso não afetará a legalidade de qualquer atividade realizada anteriormente à sua retirada
              de consentimento. Além disso, se você retirar o seu consentimento, talvez não possamos fornecer
              determinados produtos, serviços, benefícios ou vantagens. Caso isso possa ocorrer, forneceremos
              informações específicas a você para ajudar na sua tomada de decisão.
            </li>
          </ul>

          <ul>
            <li>
              <b>Revisão de decisões automatizadas: </b>Você pode solicitar a revisão de decisões tomadas unicamente com
              base no tratamento automatizado de seus Dados Pessoais que afetem seus interesses.
            </li>
          </ul>

          <p>
            Em alguns casos, você terá a opção de não fornecer certos Dados Pessoais e/ou de não permitir certas formas
            de tratamento (ao não fornecer o seu consentimento para uma finalidade específica, por exemplo). Nesses
            casos, é importante ter em mente que alguns Dados e/ou algumas autorizações específicas que dependem do seu
            consentimento podem ser condição para que você possa usufruir de alguns de nossos produtos, serviços,
            benefícios e facilidades. Sempre que esse for o caso e o tratamento dos seus Dados for condição para
            determinada finalidade, você será informado antes que possa tomar uma decisão sobre isso.
          </p>

          <p>
            Para apresentar uma requisição de exercício de qualquer dos direitos acima, você pode optar pelo uso dos
            meios descritos abaixo para entrar em contato com o encarregado pelo tratamento de dados pessoais da Rappi:{' '}
          </p>

          <p>
            <b>Atendimento Eletrônico:</b>&nbsp;um requerimento deve ser apresentado por meio do envio do requerimento
            atraves do{' '}
            <a href="https://docs.google.com/forms/d/e/1FAIpQLSc-cgyQrYBxwJl683e74KYB5fCeXgAMYHCGCewcZ5ujKONYvQ/viewform">
              Formulário de Exclusão de Conta
            </a>
            .
          </p>

          <p>
            <b>Atendimento Escrito:</b>&nbsp;um requerimento deve ser apresentado por meio do envio de uma solicitação
            escrita endereçada à Rappi, no endereço: Av dos Autonomistas, 896, torre 1, cj 1211, Vila Yara, Osasco/SP,
            Brasil, CEP. 06020-010, sendo necessária a indicação do endereço escolhido para o posterior recebimento de
            notificações e respostas da Rappi.
          </p>

          <p>
            Em qualquer dos casos, para a sua segurança e, para que possamos validar a sua identidade e confirmar que
            você está solicitando Dados Pessoais sobre os quais você efetivamente detém direitos, precisaremos submeter
            a sua requisição a um processo de validação interna de identidade. Durante esse processo, solicitaremos o
            cumprimento dos seguintes requisitos:
          </p>

          <ol>
            <li>
              Você deverá ser o Titular dos Dados sobre os quais você faça algum requerimento, provando sua identidade
              mediante a apresentação de evidências que provem a sua identidade de forma suficiente, de acordo com o
              critério exclusivo da Rappi;
            </li>
            <li>
              Caso você seja um sucessor legítimo de um Usuário na forma da lei, os requisitos do item ‘<b>1</b>’ acima
              deverão ser aplicáveis não somente ao Usuário, mas também a você e à sua condição de sucessor legítimo do
              Usuário; e
            </li>
            <li>
              Caso você seja um representante ou procurador de um Usuário, os requisitos do item ‘<b>1</b>’ acima
              deverão ser aplicáveis não somente ao Usuário, mas também a você e à sua condição de representante ou
              procurador do Usuário. Estes requisitos também se aplicam a representantes legais de crianças,
              adolescentes e incapazes.
            </li>
          </ol>

          <p>
            <b>LIMITAÇÕES AOS DIREITOS DOS USUÁRIOS</b>: EM ALGUNS CASOS, A RAPPI PODE TER MOTIVOS LEGÍTIMOS PARA DEIXAR
            DE ATENDER A UMA SOLICITAÇÃO DE EXERCÍCIO DE DIREITOS. ESSAS SITUAÇÕES INCLUEM, POR EXEMPLO, CASOS EM QUE
            UMA REVELAÇÃO DE INFORMAÇÕES ESPECÍFICAS PODERIA VIOLAR DIREITOS DE PROPRIEDADE INTELECTUAL OU SEGREDOS DE
            NEGÓCIO DA RAPPI OU DE TERCEIROS, BEM COMO CASOS EM QUE PEDIDOS DE ANONIMIZAÇÃO, BLOQUEIO OU ELIMINAÇÃO DE
            DADOS NÃO POSSAM SER ATENDIDOS EM RAZÃO DA EXISTÊNCIA DE OBRIGAÇÃO DA RAPPI DE RETER DADOS, SEJA PARA
            CUMPRIR OBRIGAÇÕES LEGAIS, REGULATÓRIAS OU PARA POSSIBILITAR A DEFESA DE DIREITOS DA RAPPI OU DE TERCEIROS,
            INCLUSIVE EM DISPUTAS DE QUALQUER NATUREZA.
            <br />
            <br />
          </p>

          <p>
            <b>7. Política de Proteção de Dados Pessoais </b>
          </p>

          <p>
            A Rappi sempre planeja e toma medidas técnicas, administrativas e organizacionais para proteger todos os
            Dados Pessoais que trata contra perdas, usos não autorizados ou outras situações ilícitas ou acidentais de
            tratamento indevido. Todos os Dados Pessoais tratados pela Rappi são armazenados e processados em ambientes
            operacionais seguros não acessíveis ao público.
          </p>

          <p>
            Com a finalidade de garantir a segurança de seus Dados Pessoais na nossa operação da Plataforma, adotamos as
            melhores práticas de segurança da informação disponíveis, incluindo o uso de soluções de criptografia ponto
            a ponto para transmitir os Dados Pessoais e outras informações. Não é permitida a utilização de nenhum
            dispositivo, software, ou outro recurso que venha a interferir nas atividades e operações do RAPPI e/ou da
            PARCEIRA DO ARRANJO, bem como nas publicações de oferta, descrições, contas ou seus bancos de dados.
            Qualquer intromissão, tentativa de, ou atividade que viole ou contrarie as leis de direito de propriedade
            intelectual e/ou as proibições estipuladas neste instrumento, tornarão o responsável passível das ações
            legais pertinentes, bem como das sanções aqui previstas, sendo ainda responsável pelas indenizações por
            eventuais danos causados.
          </p>

          <p>
            A entrada ou uso não autorizado de contas, falhas de hardware ou software e outros fatores alheios à vontade
            e ao controle razoável da Rappi podem comprometer a segurança dos seus Dados Pessoais a qualquer momento.
            Por isso, pedimos que você nos ajude a manter um ambiente seguro para todos. Além de manter as suas
            informações de acesso à Plataforma secretas e adotar práticas visando à segurança da sua conta e aos seus
            Dados, pedimos que caso você identifique ou tome conhecimento de algo que comprometa a segurança dos seus
            Dados, por favor entre em contato conosco enviando uma mensagem de e-mail para{' '}
            <a href="mailto:legal.br@rappi.com">legal.br@rappi.com</a>e detalhando a situação para que possamos
            ajudá&nbsp;&nbsp;&nbsp;&nbsp; -lo da melhor forma.
          </p>

          <p>
            <b>8. Das Disposições Gerais:</b>
          </p>

          <p>
            Como estamos sempre buscando melhorar a Plataforma e os nossos serviços, essa Política de Privacidade pode
            passar por atualizações. Desta forma, recomendamos que você visite periodicamente esta página para que tenha
            conhecimento sobre todas as modificações que faremos. Caso sejam feitas alterações relevantes, como aquelas
            que se refiram à necessidade de se obter um consentimento seu, publicaremos essa atualização e solicitaremos
            o seu consentimento, conforme a necessidade de cada caso.{' '}
          </p>

          <p>
            As disposições constantes desta Política de Privacidade poderão ser atualizadas ou modificadas a qualquer
            momento, cabendo ao USUÁRIO verificá-las sempre que efetuar o acesso à PLATAFORMA.
          </p>

          <p>
            <b>9.Lei Aplicável e Jurisdição:</b>
          </p>

          <p>
            A presente Política de Privacidade será interpretada segundo a legislação brasileira, no idioma português,
            sendo eleito o Foro da Comarca de São Paulo para dirimir qualquer litígio, questão ou dúvida superveniente,
            com expressa renúncia de qualquer outro, por mais privilegiado que seja.
          </p>

          <p>
            <b>10. Aceitação Total deste Termo</b>
          </p>

          <p>
            O USUÁRIO declara ter a capacidade legal, dando o seu CONSENTIMENTO expresso dos termos constantes desta
            Política de Privacidade, sendo que aceita a totalidade das situações reguladas neste documento
          </p>
        </div>
      </>
    )}

    {country !== 'BR' && country !== '55' && (
      <>
        <section>
          <h1>AUTORIZACIÓN TRATAMIENTO DE DATOS PERSONALES TRAVEL MOUSTACHE S.A.S.</h1>

          <p>
            <b>TRAVEL MOUSTACHE S.A.S.</b>, sociedad debidamente constituida bajo las normas de la República de
            Colombia, identificada con Nit No., 901.337.236-7 en adelante <b>“TRAVEL MOUSTACHE”</b>, informa que es
            Responsable del tratamiento de los datos personales suministrados por usted. Sus datos serán incorporados en
            nuestras bases de datos y almacenados en servidores que pueden estar ubicados en el exterior, de acceso
            exclusivo de <b>TRAVEL MOUSTACHE</b>, su matriz, subsidiarias y filiales. <b>TRAVEL MOUSTACHE</b> guardará
            confidencialidad de sus datos personales, atendiendo los requisitos y medidas de seguridad exigidos por la
            ley.
          </p>

          <p>
            El tratamiento que le dará <b>TRAVEL MOUSTACHE</b> a sus datos personales se realizará en conformidad con la{' '}
            <b>POLÍTICA DE TRATAMIENTO DE DATOS PERSONALES</b> (
            <a
              target="_blank"
              rel="noopener noreferrer"
              href="https://legal.rappi.com/colombia/politica-de-proteccion-y-tratamiento-de-datos-personales-rappi-s-a-s/"
            >
              https://legal.rappi.com/colombia/politica-de-proteccion-y-tratamiento-de-datos-personales-rappi-s-a-s/
            </a>
            ), la Ley Estatutaria 1581 de 2012, el Decreto 1377 de 2013, el Decreto 886 de 2014, el Decreto 1074 de 2015
            y las normas que las modifiquen o adicionen.
          </p>

          <p>
            <b>TRAVEL MOUSTACHE</b> podrá recolectar, organizar, almacenar y usar la información que se recaude, para
            las siguientes finalidades: (i) Recabar o recolectar los datos personales e incorporarlos y almacenarlos en
            la base de datos de <b>TRAVEL MOUSTACHE</b>, su matriz, subsidiarias y/o filiales; (ii) Ordenar, catalogar,
            clasificar, dividir o separar la información suministrada; (iii) Utilizar los datos suministrados en
            campañas de comunicación, divulgación, promoción u oferta de productos, actividades o servicios
            desarrollados como parte de estrategias internas de <b>TRAVEL MOUSTACHE</b>; (iv) Utilizar los datos
            personales para fines administrativos internos o comerciales tales como: estudios de crédito, elaboración y
            presentación de cotizaciones, facturas, referencias comerciales de experiencia, investigación de mercados,
            análisis estadísticos, realización de encuestas sobre satisfacción; (v) Conservar registros históricos de la
            compañía y mantener contacto con los titulares de los datos; (vi) Verificar, comprobar o validar los datos
            suministrados; (vii) Estudiar y analizar la información entregada para el seguimiento y mejoramiento del
            servicio y la atención; (viii) Recabar, tener, manejar y utilizar la información recibida por el titular de
            la información para realizar la vinculación como cliente o proveedor; (ix) Recabar, tener, manejar y
            utilizar la información para realizar control y prevención de fraude, control y prevención de lavado de
            activos y financiación del terrorismo; (x) Celebración, ejecución y gestión de las propuestas de negocios y
            contratos objeto de los servicios prestados; (xi) Realizar de conformidad con la ley los reportes a
            centrales de riesgo por incumplimiento de las obligaciones financieras derivadas de la relación comercial;
            (xii) Gestionar las peticiones, quejas y/o reclamos presentadas por los Usuarios/Consumidores; (xiii)
            Desarrollar estudios y programas para determinar hábitos de consumo de los Usuarios/Consumidores; (xiv)
            Realizar evaluaciones periódicas de los productos y/o servicios comercializados a través del botón
            denominado “RappiTravel”; (xv) Enviar comunicaciones por medio de la plataforma de contacto Rappi y medios
            electrónicos como lo son, pero sin limitarse a: SMS, correo electrónico, push notification y WhatsApp acerca
            de información técnica, operativa, de marketing y comercial de productos y/o servicios ofrecidos por{' '}
            <b>TRAVEL MOUSTACHE</b>, sus filiales y/o proveedores; (xvi) Enviar alertas de precios ofrecidos dentro del
            botón “RappiTravel” y en general, dentro de la plataforma de contacto Rappi; (xvii) Prestar de forma
            efectiva los servicios exhibidos a través del botón “RappiTravel” dentro de la plataforma de contacto Rappi;
            (xviii) Dar cabal cumplimiento a sus obligaciones como Agencia de Viajes, incluyendo pero sin limitarse a la
            correcta ejecución del contrato de prestación de servicios entre <b>TRAVEL MOUSTACHE</b> y el
            Usuario/Consumidor; (xix) Enviar información al Usuario/Consumidor sobre modificaciones en las condiciones
            de los productos y/o servicios adquiridos y, notificarle sobre nuevos productos y/o servicios; (xx) La
            debida confirmación y procesamiento de las transacciones realizadas a través del botón “RappiTravel” con la
            entidad financiera del Usuario/Consumidor; (xxi) Transmitir o transferir datos personales a otras personas
            naturales o jurídicas; (xxii) Transmitir o transferir datos personales a países que pueden tener un nivel de
            protección diferente al colombiano; (xxiii) Dar respuesta a consultas, peticiones, quejas y/o reclamos
            presentados por organismos de control y demás autoridades; (xxiv) Cualquier otra actividad de naturaleza
            similar a las anteriormente descritas que sean necesarias para desarrollar el objeto social de{' '}
            <b>TRAVEL MOUSTACHE</b>.
          </p>

          <p>
            En caso de autorizar a <b>TRAVEL MOUSTACHE</b> para el tratamiento y procesamiento de sus datos personales,
            el titular tendrá derecho a lo siguiente:
          </p>

          <ul>
            <li>
              Conocer, actualizar, rectificar, consultar sus datos personales en cualquier momento respecto a los datos
              que considere parciales, inexactos, incompletos, fraccionados y/o aquellos que induzcan a error.
            </li>
            <li>
              Solicitar en cualquier momento una prueba de la presente autorización, salvo en aquellos casos en los que
              legalmente <b>TRAVEL MOUSTACHE</b> está liberado de tener autorización para tratar los datos del titular.
            </li>
            <li>
              Ser informado por parte de <b>TRAVEL MOUSTACHE</b>, previa solicitud, respecto del uso que se le ha dado a
              los datos personales.
            </li>
            <li>
              Presentar ante la Superintendencia de Industria y Comercio las quejas que considere pertinentes para hacer
              valer su derecho de Habeas Data.
            </li>
            <li>
              Revocar la autorización y/o solicitar la supresión de algún dato personal, cuando considere que{' '}
              <b>TRAVEL MOUSTACHE</b> no ha respetado sus derechos y garantías constitucionales.
            </li>
          </ul>

          <p>
            Lo anterior se podrá realizar enviando un correo electrónico a servicioalclienteco@rappitravel.com, llamando
            al número (1) 7943250 o a través de Soporte en la plataforma de contacto Rappi, siguiendo las indicaciones
            previstas en la política de tratamiento de datos personales enunciada anteriormente. Adicionalmente, podrá
            realizar un requerimiento formal a la dirección:{' '}
            <em style={{ textDecoration: 'underline' }}>Calle 93 # 19-58, Bogotá D.C. Colombia</em>.
          </p>

          <p>
            Al hacer click en <b>“Acepto”</b> el usuario/consumidor declara y acepta que ha leído la totalidad del
            documento y que se encuentra de acuerdo con sus disposiciones y contenido.
          </p>
        </section>
      </>
    )}
  </>
);

export default Privacy;
